export const resolveApiBaseUrl = (hostname, configuredUrl) => {
  // Local POS development must use the backend running beside it, including
  // when an older bundle/environment still contains the hosted API address.
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `http://${hostname}:5000/api`;
  }
  return configuredUrl || 'https://mkbackend.onrender.com/api';
};

export const API_BASE_URL = resolveApiBaseUrl(
  typeof window !== 'undefined' ? window.location.hostname : '',
  process.env.REACT_APP_API_BASE_URL
);

if (typeof window !== "undefined") {
  window.MK_API_BASE_URL = API_BASE_URL;
  window.MK_REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
}

// if (process.env.NODE_ENV === "development") {
//   console.log("REACT_APP_API_BASE_URL:", process.env.REACT_APP_API_BASE_URL);
//   console.log("API_BASE_URL:", API_BASE_URL);
// }

export const getAppOrigin = () =>
  typeof window !== "undefined" ? window.location.origin : "";

export const getNetworkFailureMessage = (action) => {
  const origin = getAppOrigin();

  return [
    `${action} could not connect to the API.`,
    `App origin: ${origin || "unknown"}`,
    `API: ${API_BASE_URL}`,
    "Check that the backend is running and the API address is reachable. If it is reachable, check backend CORS for this app origin.",
  ].join("\n");
};
